import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { Button, Alert } from "react-bootstrap";
import RoleUtils from "../utils/roleUtils";
import TimedDisplay from "../components/TimedDisplay";
import ServiceCalls from "../utils/serviceCalls";
import { Loading } from "../components/Loading";
import "../styles/PopUps.css";

const AddCommentPopUp = (props) => {
  const { currentUser, currentCompanyId, Request, commentTableLoad, showButton, showPopupOnAction = false, actionType } = props;
  const [open, setOpen] = useState(showPopupOnAction);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAddComplete, setIsAddComplete] = useState(false);
  const [addMsg, setAddMsg] = useState("");
  const [addMsgLevel, setAddMsgLevel] = useState("");

  useEffect(() => {
    if (Request) {
      setIsLoading(false);
    }
  }, [Request]);

    useEffect(() => {
        if (showPopupOnAction) setOpen(true); // open popup if showPopupOnAction changes to true
    }, [showPopupOnAction]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        setErrorMessage("");
    };

    const resetForm = (isCancel = false) => {
        setOpen(false);
        setInputValue("");
        setErrorMessage("");
        setIsAddComplete(false);
        setErrorMessage("");
        setAddMsg("");
        setAddMsgLevel("");
        if (isCancel && props.onCancel) {
            props.onCancel();
        } else if (!isCancel && isAddComplete && addMsgLevel === "info" && commentTableLoad) {
            commentTableLoad();
        }
    };

  const handleSubmit = () => {
      const value = inputValue.trim();
      const htmlRegex = /<[^>]+>/i; // for HTML tags, no global flag
      const urlRegex = /https?:\/\/[^\s]+/i; // for URLs, no global flag


      if (value === "") {
          setErrorMessage("Comment is required.");
          return;
      }
      if (htmlRegex.test(value)) {
          setErrorMessage("HTML tags are not allowed.");
          return;
      }
      if (urlRegex.test(value)) {
          setErrorMessage("URLs are not allowed");
          return;
      }

    //Check user roles and get commentTypeId for comment object
    var roles = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.uhgRolesOnly());
    var commentTypeId = 2; //User comment by default
    if (roles) {
      commentTypeId = 1; //Admin comment
    }

    const comment = {
      VendorBankRequestId: Request.bankRequest.vendorBankRequestId,
      CommentContactId: currentUser.contactId,
      CommentTypeId: commentTypeId,
      Comment: inputValue,
      CreatedDt: new Date(),
    };

    setIsLoading(true);
    ServiceCalls.addBankRequestComment(comment)
      .then((data) => {
        setAddMsg(data ? "Comment added successfully" : "Comment failed to add");
        setAddMsgLevel(data ? "info" : "danger");
        setIsAddComplete(true); //Show alert
        props.commentTableLoad(); //Load table until request is received to display up to date comments
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
        setAddMsg("An error occurred while adding comment.");
        setAddMsgLevel("danger");
        setIsAddComplete(true);
      });
  };

  const showAlertMessage = () => {
    if (isAddComplete) {
      return (
        <TimedDisplay delay="3000" callback={resetForm}>
          <Alert variant={addMsgLevel}>{addMsg}</Alert>
        </TimedDisplay>
      );
    } else {
      return <></>;
    }
    };

    let headerText = "Add Comment";
    if (actionType === "reject") {
        headerText = "Reject Comment";
    } else if (actionType === "pendingclient") {
        headerText = "Pending Client Comment";
    }
  

    return !open && !isLoading && !showPopupOnAction ? (
    props.showButton() && (
      <Button
        id="mpa-button-popup"
        className="addCommentBtn right btn btn-primary"
        onClick={() => setOpen((o) => !o)}
      >
        {" "}
        Add Comment
      </Button>
    )
  ) : (
    <Popup open={open} modal closeOnDocumentClick={false}>
                <div className="comment-popup-area">
                    <h4 className="add-comment-header">{headerText} </h4>
        <textarea
          className="comment-input"
          value={inputValue}
          onChange={handleChange}
          maxLength={500}
          rows={3}
          />
            {errorMessage && (
               <p className="error-message">
                    {errorMessage}
                </p>
            )}
        <p className="comment-max-chars">{500 - inputValue.length} of 500</p>
        {isLoading ? (
            <Loading/>
        ) : isAddComplete ? (
          showAlertMessage()
        ) : (
          <>
            <div className="comment-buttons">
              <Button className="comment-popup-buttons" onClick={handleSubmit}>
                Add
              </Button>
              <Button className="comment-popup-buttons" onClick={() => resetForm(true)}>
                Cancel
              </Button>
            </div>
          </>
        )}
      </div>
    </Popup>
  );
};
export default AddCommentPopUp;
